var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('block',{staticClass:"product-detail-gains-block",attrs:{"title":"学员心声","more":_vm.showMore,"more-desc":"查看全部"},on:{"click-more":_vm.handleShowMore}},[_c('gain-list',{attrs:{"list":_vm.list}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }